module.exports = __webpack_public_path__ + "static/media/help-icon.579328f1.svg";